import { Pressable, StyleSheet, View } from 'react-native';
import { Plus } from 'lucide-react-native';
import { tokens } from '../../theme/tokens';
import { AppCard } from '../ui/AppCard';
import { AppText } from '../ui/AppText';

type PlanProgressCardProps = {
  completionPercent: number;
  completedCount: number;
  totalCount: number;
  onAddTask: () => void;
};

export function PlanProgressCard({
  completionPercent,
  completedCount,
  totalCount,
  onAddTask,
}: PlanProgressCardProps) {
  return (
    <AppCard style={styles.card}>
      <View style={styles.header}>
        <View>
          <AppText variant="caption" tone="muted">
            完成率
          </AppText>
          <AppText variant="metric" weight="bold" tone="primary">
            {completionPercent}%
          </AppText>
        </View>
        <Pressable accessibilityRole="button" onPress={onAddTask} style={styles.addButton}>
          <Plus size={20} color={tokens.colors.white} />
        </Pressable>
      </View>
      <View style={styles.progressTrack}>
        <View style={[styles.progressFill, { width: `${completionPercent}%` }]} />
      </View>
      <AppText variant="caption" tone="muted">
        已完成 {completedCount}/{totalCount}
      </AppText>
    </AppCard>
  );
}

const styles = StyleSheet.create({
  card: {
    gap: tokens.spacing.md,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  addButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: tokens.colors.primary,
  },
  progressTrack: {
    height: 8,
    borderRadius: 4,
    overflow: 'hidden',
    backgroundColor: tokens.colors.surfaceMuted,
  },
  progressFill: {
    height: '100%',
    borderRadius: 4,
    backgroundColor: tokens.colors.primary,
  },
});
